<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="searchForm.queryDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择"
             :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          {{ this.searchForm.queryDate+' 00:00:00' }}至  {{ this.searchForm.queryDate+' 23:59:59' }}
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="date" label="日期" width="120"></el-table-column>
        <el-table-column prop="timeSlot" label="时段" width="120"></el-table-column>
        <el-table-column label="汇总">
          <el-table-column prop="total_working" label="作业车数"></el-table-column>
          <el-table-column prop="total_charging" label="充电车数"></el-table-column>
          <el-table-column prop="total_maintaining" label="维修车数"></el-table-column>
        </el-table-column>
        <el-table-column v-for="team in teamNames" :key="team" :label="team">
          <el-table-column :prop="'team_' + team + '_working'" label="作业车数"></el-table-column>
          <el-table-column :prop="'team_' + team + '_charging'" label="充电车数"></el-table-column>
          <el-table-column :prop="'team_' + team + '_maintaining'" label="维修车数"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { statByTimeSlot } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
        queryDate: this.getYesterday()
      },
      tableList: [],
      teamNames: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      isDaoChu: false,
      // 日期限制配置
      pickerOptions: {
        disabledDate (time) {
        // 核心：只禁用 今天 之后的日期
          return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
        }
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/carStatusDistribution')
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    getYesterday () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      statByTimeSlot(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res.list
          this.teamNames = res.teamNames
          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchForm = { queryDate: this.getYesterday() }
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/tWayVehicleReport/exportStatByTimeSlot',
        form,
        '车辆状态分布'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
